// extracted by mini-css-extract-plugin
export default {"verify-mail":"verify-email_verify-mail__GQCJu"};